import { render, staticRenderFns } from "./collection-point-add.vue?vue&type=template&id=5564f787&scoped=true&"
import script from "./collection-point-add.vue?vue&type=script&lang=js&"
export * from "./collection-point-add.vue?vue&type=script&lang=js&"
import style0 from "./collection-point-add.vue?vue&type=style&index=0&id=5564f787&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564f787",
  null
  
)

export default component.exports